import { Card, CardBody, Skeleton } from '@repo/ui';

export interface SummaryCardsSkeletonProps {
  count?: number;
  columns?: {
    mobile?: number;
    tablet?: number;
    desktop?: number;
  };
  gap?: 'sm' | 'md' | 'lg';
  useSkeletonComponent?: boolean;
}

export function SummaryCardsSkeleton({
  count = 4,
  columns = { mobile: 1, tablet: 2, desktop: 4 },
  gap = 'md',
  useSkeletonComponent = false,
}: SummaryCardsSkeletonProps) {
  const gapClass = gap === 'sm' ? 'gap-2' : gap === 'md' ? 'gap-4' : 'gap-6';

  // Build grid classes properly - use specific Tailwind classes
  const mobileCols = columns.mobile === 1 ? 'grid-cols-1' : columns.mobile === 2 ? 'grid-cols-2' : columns.mobile === 3 ? 'grid-cols-3' : 'grid-cols-4';
  const tabletCols = columns.tablet === 1 ? 'md:grid-cols-1' : columns.tablet === 2 ? 'md:grid-cols-2' : columns.tablet === 3 ? 'md:grid-cols-3' : 'md:grid-cols-4';
  const desktopCols = columns.desktop === 1 ? 'lg:grid-cols-1' : columns.desktop === 2 ? 'lg:grid-cols-2' : columns.desktop === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4';

  const gridClass = `grid ${mobileCols} ${tabletCols} ${desktopCols} ${gapClass}`;

  if (useSkeletonComponent) {
    return (
      <div className={gridClass}>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height="120px" />
        ))}
      </div>
    );
  }

  return (
    <div className={gridClass}>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i}>
          <CardBody className="p-4">
            <div className="animate-pulse">
              <div className="h-4 bg-xtnd-dark-100 dark:bg-xtnd-dark-600 rounded w-3/4 mb-2"></div>
              <div className="h-8 bg-xtnd-dark-100 dark:bg-xtnd-dark-600 rounded w-1/2"></div>
            </div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}

